import { useEffect, useState } from "react";
import { computeOpenNow } from "../config/business";

export default function OpenNowBadge({ className = "" }) {
  const [state, setState] = useState(computeOpenNow());
  useEffect(() => {
    const id = setInterval(() => setState(computeOpenNow()), 60000);
    return () => clearInterval(id);
  }, []);
  const { open } = state;
  return (
    <span
      data-testid="open-now-badge"
      className={`inline-flex items-center gap-1.5 font-semibold ${open ? "text-openg" : "text-star"} ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${open ? "bg-openg" : "bg-star"} ${open ? "animate-pulse" : ""}`} />
      {open ? "Open Now" : "Closed"}
    </span>
  );
}
